const OtherDiseasesType = Symbol();

export class OtherDiseases {
    [OtherDiseasesType]: any;
    readonly value: string;

    private constructor(otherDiseases: string) {
        this.value = otherDiseases;
    }

    static fromString(otherDiseases: string): OtherDiseases {
        return new OtherDiseases(otherDiseases);
    }

    static fromNothing(): OtherDiseases {
        return new OtherDiseases("");
    }
}

export type OtherDiseasesJson = {
    diseases: string
};

export const otherDiseasesInitialState= {
    diseases: ""
};
